export const objectDefault = {
  // tt_id: 4,

  tt_nombre_turno: "",
  tt_hora_inicio: "",
  tt_hora_fin: "",
  tt_color: "",
  tt_user: "",
  tt_empresa: "",
  tt_fec_reg: "",
};
export const columns = [
  {
    id: "tt_nombre_turno",
    label: "Nombre",
    minWidth: 25,
    tipo: "string",
    propiedad: "tt_nombre_turno",
  },
  {
    id: "tt_hora_inicio",
    label: "H. Inicio",
    minWidth: 25,
    tipo: "string",
    propiedad: "tt_hora_inicio",
  },
  {
    id: "tt_hora_fin",
    label: "H. Fin",
    minWidth: 25,
    tipo: "string",
    propiedad: "tt_hora_fin",
  },
  {
    id: "tt_color",
    label: "Color",
    minWidth: 25,
    tipo: "string",
    propiedad: "tt_color",
  },
  {
    id: "tt_user",
    label: "User",
    minWidth: 25,
    tipo: "string",
    propiedad: "tt_user",
  },
  {
    id: "tt_fec_reg",
    label: "Fec. Reg.",
    minWidth: 25,
    tipo: "string",
    propiedad: "tt_fec_reg",
  },
];
